import './Hero.css';

function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero-content">
        <p className="subheading">Expert Car Detailing</p>
        <h1 className="heading">
          Interior and Exterior Cleaning for All Vehicles
        </h1>

        <div className="buttons">
          <a href="#services" className="btn dark">
            View Our Services
          </a>
        </div>

        <hr className="divider" />
      </div>
    </section>
  )
}

export default Hero